/******************************************************************************
 *
 * Copyright (c) 2019-2022 ServiceActivator Inc. All Rights Reserved.
 *
 * Unauthorized copying of the code in this file, completely or partially,
 * via any medium is strictly prohibited.
 *
 * Proprietary and Confidential.
 *
 * Written by 'Shivam Mishra' <shivam.mishra@wakencode.com>, June 2022
 *
 *****************************************************************************/

import axios from "axios";

// Base api url
const REACT_APP_BASE_SIGNUP_API = process.env.REACT_APP_BASE_SIGNUP_API;

/**
 * Api call to verify user status
 *
 * @param {object} postData Request body for verify user Mobile status
 * @returns Response from api
 */
export const verifyUserMobileStatus = (postData) => {
  let url = `${REACT_APP_BASE_SIGNUP_API}/user/status`;

  return axios.post(url, postData);
};

/**
 * Api call to verify user status
 *
 * @param {object} postData Request body for verify user Email status
 * @returns Response from api
 */
export const verifyUserEmailStatus = (postData) => {
  let url = `${REACT_APP_BASE_SIGNUP_API}/user/status`;

  return axios.post(url, postData);
};

/**
 * Api call to create user account
 *
 * @param {String} mobileNumber
 * @param {object} postData Request body for create user
 * @returns Response from api
 */
export const creatUser = (mobileNumber, postData) => {
  let url = `${REACT_APP_BASE_SIGNUP_API}/user/+1${mobileNumber}`;

  return axios.post(url, postData);
};

/**
 * Api call to send verification code to user mobile
 *
 * @returns Response from api
 */
export const generateVerificationCode = (postData) => {
  let url = `${REACT_APP_BASE_SIGNUP_API}/user/verify/mobile`;

  return axios.post(url, postData);
};

/**
 * Api call to verify user entered verification code
 *
 * @param {String} verificationCode
 * @returns Response from api
 */
export const verifyVerificationCode = (postData) => {
  let url = `${REACT_APP_BASE_SIGNUP_API}/user/verify`;
  return axios.post(url, postData);
};

/**
 * Api call to get user information
 *
 * @param {object} config header config
 * @returns Response from api
 */
export const getUserInfo = (config) => {
  let url = `${REACT_APP_BASE_SIGNUP_API}/user`;
  return axios.get(url, config);
};

/**
 * Api call to generate verification code for email
 *
 * @param {object} config header config
 * @param {object} postData request body
 * @returns Response from api
 */
export const generateVerificationCodeForEmail = (config, postData) => {
  let url = `${REACT_APP_BASE_SIGNUP_API}/user/verify/email`;
  return axios.post(url, postData, config);
};

/**
 * Api call to generate verification code for email
 *
 * @param {object} config header config
 * @param {object} postData request body
 * @returns Response from api
 */
export const verifyEmailVerificationCode = (config, postData) => {
  let url = `${REACT_APP_BASE_SIGNUP_API}/user/verify`;
  return axios.post(url, postData, config);
};

/**
 * Api call to update user information
 *
 * @param {object} postData User entered information
 * @param {object} config configurations for api
 * @returns Response from api
 */
export const updateInfo = (postData, config) => {
  let url = `${REACT_APP_BASE_SIGNUP_API}/user`;
  return axios.post(url, postData, config);
};

/**
 * Api call to create subscriber
 *
 * @param {object} config configurations for api
 * @returns Response from api
 */
export const createSubscriber = (config) => {
  let url = `${REACT_APP_BASE_SIGNUP_API}/owner/subscriber`;
  return axios.post(url, undefined, config);
};

/**
 * Api call to activate owner
 *
 * @param {object} config configurations for api
 * @returns Response from api
 */
export const activateOwner = (config) => {
  let url = `${REACT_APP_BASE_SIGNUP_API}/owner/activate`;
  return axios.post(url, undefined, config);
};

/**
 * Api call to send marketing email/request invitation
 *
 * @param {object} config configurations for api
 * @returns Response from api
 */
export const inviteSubscriberOwner = (config) => {
  let url = `${REACT_APP_BASE_SIGNUP_API}/owner/invite`;
  return axios.post(url, undefined, config);
};

/**
 * Api call to activate invited employee
 *
 * @param {object} config configurations for api
 * @returns Response from api
 */
export const activateEmployee = (config) => {
  let url = `${REACT_APP_BASE_SIGNUP_API}/employee/activate`;
  return axios.post(url, undefined, config);
};

/**
 * Api call to activate new employee
 *
 * @param {object} config configurations for api
 * @returns Response from api
 */
export const activateNewEmployee = (config) => {
  let url = `${REACT_APP_BASE_SIGNUP_API}/hub/activate`;
  return axios.post(url, undefined, config);
};

// /**
//  * Api call to upload profile picture
//  *
//  * @param {base64} fileData Base64 format of user entered image
//  * @param {*} fileName Name of the image
//  * @returns Response from api
//  */
// export const uploadProfileImage = (fileData, fileName) => {
//   let mobile = localStorage.getItem("mobileNumber");
//   let postData = { fileData, fileName };
//   let url = `${baseURL}/user/signup/${mobile}/image`;
//   return axios.post(url, postData);
// };

// /**
//  * Api call to get user information if user is invited
//  *
//  * @param {String} invitationCode Invitation code fetched from invitation url
//  * @param {String} inviteeMobile Invitation number fetched from invitation url
//  * @returns User information
//  */
// export const fetchInvitaionData = (invitationCode, inviteeMobile) => {
//   return axios.get(
//     `${baseURL}/user/signup/${inviteeMobile}/invite?code=${invitationCode}`
//   );
// };

// /**
//  * Api call to activating user account
//  *
//  * @returns Response from api
//  */
// export const getAccountActivationStatus = () => {
//   let mobile = localStorage.getItem("mobileNumber");
//   let url = `${baseURL}/user/signup/${mobile}/commit`;
//   return axios({
//     url: url,
//     method: "post",
//     data: {},
//     timeout: 1000 * 60,
//   });
// };

// export const emailVerificationSync = () => {
//   const url = `${baseURL}/user/verify/email/sync` ;
//   return axios.post(url, {});
// };
